import {
  matchesSearch,
  LookupField,
  createLookupModel,
} from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import { Row, Col } from 'src/componentes/grid';

import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import ModeloRiscoLookup from 'src/lookups/modelo-risco';
import MatrizRiscoLookup from 'src/lookups/matriz-risco';
import TipoRiscoLookup from 'src/lookups/tipo-risco';
import StatusItemLookup from 'src/lookups/status-item';
import ColaboradorSimplificadoLookup from 'src/lookups/ColaboradorSimplificadoLookup';
import TagLookup from 'src/lookups/TagLookup';
import ClassificacaoRiscoLookup from 'src/lookups/classificacao-risco';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';

/**
 * Seção de Informações Básicas
 */
const BasicsSection = ({
  model,
  resources,
  intl,
  configuracao,
  searchQuery,
}) => {
  const fields = [
    { label: intl.formatMessage({ id: 'idIntegracao' }), id: 'idIntegracao' },
    { label: intl.formatMessage({ id: 'nome' }), id: 'nome' },
    { label: resources.responsaveis, id: 'responsaveis' },
    {
      label: intl.formatMessage(
        { id: 'label.responsavelAvaliacao' },
        { avaliacao: resources.avaliacao }
      ),
      id: 'responsavelAvaliacao',
    },
    { label: resources.areas, id: 'areas' },
    {
      label: intl.formatMessage(
        { id: 'label.considerarAreasSubordinadas' },
        { areas: intl.formatMessage({ id: 'areas' }) }
      ),
      id: 'areasSubordinadas',
    },
    { label: intl.formatMessage({ id: 'matrizRisco' }), id: 'matrizRisco' },
    configuracao?.utilizarTipo && {
      label: intl.formatMessage({ id: 'tipoRisco' }),
      id: 'tipoRisco',
    },
    configuracao?.utilizarModelo && {
      label: intl.formatMessage({ id: 'modelo' }),
      id: 'modelo',
    },
    configuracao?.podeVisualizarTag && {
      label: resources.tags,
      id: 'tags',
    },
    configuracao?.utilizarClassificacaoRisco && {
      label: intl.formatMessage({ id: 'label.classificacao' }),
      id: 'classificacoesRisco',
    },
    { label: intl.formatMessage({ id: 'status' }), id: 'status' },
    {
      label: intl.formatMessage({ id: 'desconsiderarStatusConcluido' }),
      id: 'desconsiderarStatusConcluido',
    },
    {
      label: intl.formatMessage({ id: 'desconsiderarStatusCancelado' }),
      id: 'desconsiderarStatusCancelado',
    },
  ].filter(Boolean);

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;

  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) {
    return null;
  }

  return (
    <CollapsibleSection
      title={intl.formatMessage({ id: 'label.informacoesBasicas' })}
      defaultOpen={true}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {visibleFields.includes(fields.find((f) => f.id === 'idIntegracao')) &&
          model?.getModel('idIntegracao') && (
            <Col md={12}>
              <Input model={model.getModel('idIntegracao')} />
            </Col>
          )}

        {visibleFields.includes(fields.find((f) => f.id === 'nome')) &&
          model?.getModel('nome') && (
            <Col md={12}>
              <Input model={model.getModel('nome')} />
            </Col>
          )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'responsaveis')
        ) && (
          <Col md={12}>
            <LookupField
              Component={ColaboradorSimplificadoLookup}
              multi
              clearable
              highlight={matchesSearch(resources?.responsaveis, searchQuery)}
              model={createLookupModel(
                resources?.responsaveis,
                model.getModel('responsaveis')?.value,
                model.getModel('responsaveis')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'responsavelAvaliacao')
        ) && (
          <Col md={12}>
            <ColaboradorEGrupoSimplificadoLookup
              abrirEmDrawer
              clearable
              multi
              data={{ ocultarInativos: true }}
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'label.responsavelAvaliacao' },
                  {
                    avaliacao: resources.avaliacao,
                  }
                ),
                model.getModel('responsavelAvaliacao')?.value,
                model.getModel('responsavelAvaliacao')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(fields.find((f) => f.id === 'areas')) && (
          <Col md={12}>
            <LookupField
              Component={ItemOrganizacaoLookup}
              multi
              highlight={matchesSearch(resources?.areas, searchQuery)}
              model={createLookupModel(
                resources?.areas,
                model.getModel('areas')?.value,
                model.getModel('areas')?.requestChange
              )}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'areasSubordinadas')
        ) && (
          <Col md={12}>
            <Checkbox
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'label.considerarAreasSubordinadas' },
                  { areas: resources?.areas || 'Áreas' }
                ),
                model.getModel('areasSubordinadas')?.value,
                model.getModel('areasSubordinadas')?.requestChange
              )}
              style={{ marginBottom: 10 }}
            />
          </Col>
        )}

        {visibleFields.includes(fields.find((f) => f.id === 'matrizRisco')) && (
          <Col md={12}>
            <LookupField
              Component={MatrizRiscoLookup}
              clearable
              highlight={matchesSearch('matriz', searchQuery)}
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'matrizRisco' },
                  { risco: resources?.risco || 'Risco' }
                ),
                model.getModel('matrizRisco')?.value,
                model.getModel('matrizRisco')?.requestChange
              )}
            />
          </Col>
        )}

        {configuracao?.utilizarTipo &&
          visibleFields.includes(fields.find((f) => f.id === 'tipoRisco')) && (
            <Col md={12}>
              <LookupField
                Component={TipoRiscoLookup}
                clearable
                highlight={matchesSearch(resources?.tipoRisco, searchQuery)}
                model={createLookupModel(
                  resources?.tipoRisco,
                  model.getModel('tipoRisco')?.value,
                  model.getModel('tipoRisco')?.requestChange
                )}
              />
            </Col>
          )}

        {configuracao?.utilizarModelo &&
          visibleFields.includes(fields.find((f) => f.id === 'modelo')) && (
            <Col md={12}>
              <LookupField
                Component={ModeloRiscoLookup}
                clearable
                highlight={matchesSearch('modelo', searchQuery)}
                model={createLookupModel(
                  intl.formatMessage({ id: 'modelo' }),
                  model.getModel('modeloRisco')?.value,
                  model.getModel('modeloRisco')?.requestChange
                )}
              />
            </Col>
          )}

        {configuracao?.podeVisualizarTag &&
          visibleFields.includes(fields.find((f) => f.id === 'tags')) && (
            <Col md={12}>
              <LookupField
                Component={TagLookup}
                multi
                highlight={matchesSearch(
                  intl.formatMessage({ id: 'tags' }),
                  searchQuery
                )}
                model={createLookupModel(
                  resources.tags,
                  model.getModel('tags')?.value,
                  model.getModel('tags')?.requestChange
                )}
                data={{ funcionalidadesIdSelecionaveis: [7] }}
                podeEditar={false}
              />
            </Col>
          )}

        {configuracao?.utilizarClassificacaoRisco &&
          visibleFields.includes(
            fields.find((f) => f.id === 'classificacoesRisco')
          ) && (
            <Col md={12}>
              <LookupField
                Component={ClassificacaoRiscoLookup}
                multi
                clearable
                highlight={matchesSearch(
                  intl.formatMessage({ id: 'label.classificacao' }),
                  searchQuery
                )}
                model={createLookupModel(
                  intl.formatMessage({ id: 'label.classificacao' }),
                  model.getModel('classificacoesRisco')?.value,
                  model.getModel('classificacoesRisco')?.requestChange
                )}
              />
            </Col>
          )}

        {visibleFields.includes(fields.find((f) => f.id === 'status')) && (
          <Col md={12}>
            <LookupField
              Component={StatusItemLookup}
              clearable
              highlight={matchesSearch(
                intl.formatMessage({ id: 'status' }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'status' }),
                model.getModel('status')?.value,
                model.getModel('status')?.requestChange
              )}
              data={{ idsSelecionados: [1, 2, 3, 4, 5, 7, 8] }}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'desconsiderarStatusConcluido')
        ) && (
          <Col md={12}>
            <Checkbox
              model={createLookupModel(
                intl.formatMessage({ id: 'desconsiderarStatusConcluido' }),
                model.getModel('desconsiderarStatusConcluido')?.value,
                model.getModel('desconsiderarStatusConcluido')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'desconsiderarStatusCancelado')
        ) && (
          <Col md={12}>
            <Checkbox
              model={createLookupModel(
                intl.formatMessage({ id: 'desconsiderarStatusCancelado' }),
                model.getModel('desconsiderarStatusCancelado')?.value,
                model.getModel('desconsiderarStatusCancelado')?.requestChange
              )}
              style={{ marginTop: 5 }}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};
export default BasicsSection;
